import { HisSearchResultRow } from 'hisng';
import { AbstractDetailViewListEntry, SimpleLinkDefinition, RowLabels } from './abstract-detail-view-list-entry';
import { DetailViewListUtils } from './detail-view-list-utils';


export class ProjectDetailViewListEntry extends AbstractDetailViewListEntry {

    rowLabels: RowLabels = {
        status: 'fs.res.project.Project.projectStatusId',
        title: 'fs.res.finance.project.Project.defaulttext',
        teamMembers: 'fs.res.finance.project.search.Project.teamMembers',
        projectHeads: 'fs.res.finance.project.search.Project.projectHeads',
        startDate: 'fs.res.finance.project.search.Project.startdate',
        endDate: 'fs.res.finance.project.search.Project.enddate'
    };

    getOverSearchResultLink(): SimpleLinkDefinition {
        return null;
    }

    getSubheading(row: HisSearchResultRow, data: any, index: number): string {
        return null;
    }

    getHeaderLine(row: HisSearchResultRow): string {
        return `${this.hisUiService.translate('fs.res.project.Project.category')} | ` +
            DetailViewListUtils.capitalizeFirstLetter(DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['status']));
    }

    getTitleLine(row: HisSearchResultRow): string {
        return DetailViewListUtils.getRowByLabelKey(row, this.rowLabels.title);
    }

    getToolTip(row: HisSearchResultRow): string {
        return DetailViewListUtils.assembleToolTip(this.hisUiService.translate('fs.res.project'),
            DetailViewListUtils.getRowByLabelKey(row, this.rowLabels.title), this.hisBaseGlobalsService, this.hisUiService);
    }

    getTitleLink(row: HisSearchResultRow): string {
        return `/a/fs.res.frontend/finance/project/view/${row.get('Project.lid')}` +
            '?showBackButton=true&showSearchButton=false';
    }

    getExtendableLine(row: HisSearchResultRow, i: number, first: number, rowsPerPage: number): string {
        const projectHeadsNames = DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['projectHeads']);
        const projectHeadsNamesSplit = projectHeadsNames ? projectHeadsNames.split(', ') : [];
        const firstProjectHeadsNames = `${projectHeadsNamesSplit[0]},
                                    ${projectHeadsNamesSplit[1]},
                                    ${projectHeadsNamesSplit[2]} et al.`;
        const textPrefixProjectHeads = this.hisUiService.translate('fs.res.finance.project.projectHeads') + ': ';
        let textProjectHeads;

        if (projectHeadsNamesSplit.length === 0) {
            textProjectHeads = '';
        } else if (projectHeadsNamesSplit.length <= 3
            || this.personDetailViewSearchResultComponent.isShowExtendableLine(i, first, rowsPerPage)) {
            textProjectHeads = textPrefixProjectHeads + projectHeadsNames;
        } else {
            textProjectHeads = textPrefixProjectHeads + firstProjectHeadsNames;
        }
        return textProjectHeads;
    }

    getExtendableLineSecond(row: HisSearchResultRow, i: number, first: number, rowsPerPage: number): string {
        const projectMemberNames = DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['teamMembers']);
        const projectMemberNamesSplit = projectMemberNames ? projectMemberNames.split(', ') : [];
        const firstMemberNames = `${projectMemberNamesSplit[0]},
                              ${projectMemberNamesSplit[1]},
                              ${projectMemberNamesSplit[2]} et al.`;
        const textPrefix = this.hisUiService.translate('fs.res.finance.project.teamMembers') + ': ';
        let textProjectMembers;

        if (projectMemberNamesSplit.length === 0) {
            textProjectMembers = '';
        } else if (this.shouldShowFullMemberList(projectMemberNamesSplit, i, first, rowsPerPage)) {
            textProjectMembers = textPrefix + projectMemberNames;
        } else {
            textProjectMembers = textPrefix + firstMemberNames;
        }
        return textProjectMembers;
    }

    private shouldShowFullMemberList(projectMemberNamesSplit: string[], i: number, first: number, rowsPerPage: number): boolean {
        return projectMemberNamesSplit.length <= 3 ||
            this.personDetailViewSearchResultComponent.isShowAll(this.personDetailViewSearchResultComponent.extendableLineShowAllSecond,
                i, first, rowsPerPage);
    }

    isExtendable(row: HisSearchResultRow): boolean {
        const projectHeadsNames = DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['projectHeads']);
        const projectHeadsNamesSplit = projectHeadsNames ? projectHeadsNames.split(', ') : [];
        return projectHeadsNamesSplit.length > 3;
    }

    isExtendableSecond(row: HisSearchResultRow): boolean {
        const projectMemberNames = DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['teamMembers']);
        const projectMemberNamesSplit = projectMemberNames ? projectMemberNames.split(', ') : [];
        return projectMemberNamesSplit.length > 3;
    }

    getFooterLine(row: HisSearchResultRow): string {
        return `${DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['startDate'])} - ` +
            DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['endDate']);
    }

}
